module.exports = __webpack_public_path__ + "static/media/pallet.b4eda06b.svg";